export default __webpack_public_path__ + "static/media/watch-check.032ef2d3.svg";